<template lang="pug">
  page(
    main-title="Выгрузка заказов в службы доставки",
    :links="[ { component: 'OrdersTransferList', title: 'Выгрузка заказов' }, 'Редактировать данные' ]"
  )
    template(slot="description") Редактирование данных заказа <b> {{ salesbeatOrderId }} </b>
    div.panel
      div.panel-body
        div.row
          div.col-md-4
            string-input(
              v-model="form.full_name"
              label="ФИО получателя"
              :valid="!Boolean(validation.full_name)"
              :message="validation.full_name"
            )
          div.col-md-4
            // TODO: подумать тут над маскировкой – сейчас не делаю, чтобы не потерять
            //  заполненные данные (например, из тильды может прийти совсем дичь)
            string-input(
              v-model="form.phone"
              label="Номер телефона получателя"
              :valid="!Boolean(validation.phone)"
              :message="validation.phone"
            )
          div.col-md-4
            string-input(
              v-model="form.email"
              label="Email получателя"
              :valid="!Boolean(validation.email)"
              :message="validation.email"
            )
        div.row.margin-bottom-10
          div.col-md-4
            select-input(
              v-model="form.city"
              label="Доставка в"
              search-path="/fias/autocomplete/"
              display-field="full_name"
              :clearable="false"
              :valid="!Boolean(validation.city)"
              :message="validation.city"
            )
          div.col-md-4
            select-input(
              v-model="form.delivery_method"
              label="Способ доставки"
              :search-path="SEARCH_DELIVERY_METHOD"
              :filters="[ { name: 'with_order_transfer', value: true } ]"
              :clearable="false"
              :valid="!Boolean(validation.delivery_method)"
              :message="validation.delivery_method"
            )
          div.col-md-4
            number-input(
              v-model="form.delivery_price"
              label="Стоимость доставки, руб."
              :valid="!Boolean(validation.delivery_price)"
              :message="validation.delivery_price"
            )
        template(v-if="form.delivery_method")
          template(v-if="form.delivery_method.delivery_type === 'pvz'")
            p.margin-bottom-10 Доставка до <b>пункта выдачи заказов</b>
            div.row
              div.col-md-4
                string-input(
                  v-model="form.pvz.id"
                  label="ID ПВЗ"
                  :valid="!Boolean(validation.pvz_id)"
                  :message="validation.pvz_id"
                )
          template(v-else)
            p.margin-bottom-10 Доставка <b>курьером</b> по адресу
            div.row
              div.col-md-4.col-xs-9
                string-input(
                  v-model="form.courier.street"
                  label="Улица"
                  :valid="!Boolean(validation.courier_street)"
                  :message="validation.courier_street"
                )
              div.col-lg-1.col-md-2.col-xs-3
                string-input(
                  v-model="form.courier.house"
                  label="Дом"
                  :valid="!Boolean(validation.courier_house)"
                  :message="validation.courier_house"
                )
              div.col-lg-1.col-md-2.col-xs-6
                string-input(
                  v-model="form.courier.house_block"
                  label="Корпус/строение"
                )
              div.col-lg-1.col-md-2.col-xs-6
                string-input(
                  v-model="form.courier.flat"
                  label="Квартира"
                )
        
        template(v-if="form.comment")
          div.row.margin-bottom-5
            div.col-md-12
              h4 Комментарий к заказу

          div.row.margin-bottom-10
            div.col-md-12 {{ form.comment }}

        div.row.margin-bottom-5
          div.col-md-12
            h4 Товары

        template(v-for="(product, index) in form.productsItems")
          div.row(v-if="editingProductItemIndex !== index")
            div.col-md-12
              div.EditOrder-ProductItem
                code.EditOrder-ProductItem-Code(:title="product.id") {{ product.id }}
                |  {{ product.name }},
                |  <b>{{ product.price_to_pay }}</b> руб.
                template(v-if="product.price_to_pay !== product.price_insurance")
                  |  (страховка – {{ product.price_insurance }} руб.)
                | ,
                template(v-if="product.x")
                  |  {{ product.x }}x{{product.y}}x{{product.z}}см
                template(v-else) габариты не указаны
                | , {{ product.weight }} грамм
                template(v-if="product.quantity > 1")
                  | , количество – {{ product.quantity }}
                template(v-if="productsIsEditable")
                  |  – <a href="#" @click.prevent="editProductItem(index)"> изменить </a>
                  |  /<a href="#" @click.prevent="removeProductItem(index)"> удалить </a>
          edit-product.EditOrder-EditingProductItem(
            v-else,
            :product="product",
            @save="updateProductItem($event, index)"
          )

        div.row(v-if="productsIsEditable && editingProductItemIndex !== null")
          div.col-md-12
            a(href="#", @click.prevent="editProductItem(null)") добавить

        edit-product.EditOrder-EditingProductItem(
          v-if="editingProductItemIndex === null",
          :product="{}",
          @save="updateProductItem($event, null)"
        )

        div.row.margin-top-10
          div.col-md-12
            button.btn.btn-o.btn-primary(@click="save") Сохранить
            button.btn.btn-o.btn-primary.pull-right(@click="cancel") Отмена
</template>

<script>
    import _cloneDeep from 'lodash/cloneDeep';

    import NumberInput from '@/lib/fields/NumberInput';
    import StringInput from '@/lib/fields/StringInput';
    import SelectInput from '@/lib/fields/SelectInput';
    import EditProduct from './EditProduct';
    import { SEARCH_DELIVERY_METHOD } from '@/store/api-points';

    export default {
        name: 'EditOrder',

        components: {
            EditProduct,
            NumberInput,
            SelectInput,
            StringInput
        },

        created() {
            if (!this.item || !this.item.order) {
                this.fetchOrder();
            }
        },

        props: {
            salesbeatOrderId: {
                required: true,
                type: String
            },
            item: {
                type: Object
            }
        },

        methods: {
            fetchOrder() {
                this.$store.dispatch('fetchOrders', { id: this.salesbeatOrderId })
                    .then(({ items }) => {
                        this.currentItem = items[0];
                        this.form = this.getForm(this.currentItem);
                    });
            },

            getForm({
                order,
                recipient,
                products,

                delivery_method_id: deliveryMethodId,
                delivery_method_name: deliveryMethodName,
                delivery_method_type: deliveryMethodType
            } = {}) {
                order = (this.item && this.item.order) || order;
                recipient = (this.item && this.item.recipient) || recipient;
                products = (this.item && this.item.products) || products;

                if (!order) {
                    return {};
                }

                const { delivery_price, comment = '' } = order;
                const {
                    full_name,
                    phone,
                    email,
                    courier = {},
                    pvz = {},
                    city
                } = (this.item && this.item.recipient) || recipient;

                const productsItems = _cloneDeep(
                    ((this.item && this.item.products) || products).items
                );

                return {
                    delivery_price,
                    comment,

                    full_name,
                    phone,
                    email,
                    courier: { ...courier },
                    pvz: { ...pvz },

                    city,
                    delivery_method: {
                        id: (this.item && this.item.delivery_method_id) || deliveryMethodId,
                        name: (this.item && this.item.delivery_method_name) || deliveryMethodName,
                        delivery_type: (this.item && this.item.delivery_method_type) || deliveryMethodType,
                        code: order.delivery_method_code
                    },

                    productsItems
                };
            },

            // На мобилках можно добавить element.scrollIntoView,
            // чтобы удобненько подскролить к месту редактирования
            editProductItem(index) {
                this.editingProductItemIndex = index;
            },

            removeProductItem(index) {
                this.form.productsItems.splice(1, 1);
            },

            updateProductItem(newValue, index) {
                if (index === null) {
                    this.form.productsItems.push(newValue);
                } else {
                    this.form.productsItems[index] = newValue;
                }

                this.editingProductItemIndex = undefined;
            },

            validate() {
                let valid = true;
                const requiredMessage = 'Уж заполните, пожалуйста';

                for (const field of this.REQUIRED_FIELDS) {
                    if (!this.form[field]) {
                        valid = false;
                        this.$set(this.validation, field, requiredMessage);
                    }
                }

                if (this.form.delivery_method.delivery_type === 'pvz') {
                    if (!this.form.pvz.id) {
                        valid = false;
                        this.$set(this.validation, 'pvz_id', requiredMessage);
                    }
                } else {
                    for (const field of [ 'street', 'house' ]) {
                        if (!this.form.courier[ field ]) {
                            valid = false;
                            this.$set(this.validation, `courier_${field}`, requiredMessage);
                        }
                    }
                }

                return valid;
            },

            save() {
                if (!this.validate()) {
                    return;
                }

                this.$store.dispatch('saveOrder', {
                    id: this.salesbeatOrderId,
                    order: {
                        order: {
                            id: this.currentItem.order.id,
                            delivery_from_shop: this.currentItem.delivery_from_shop,
                            delivery_method_code: this.form.delivery_method.code,
                            delivery_price: this.form.delivery_price
                        },
                        recipient: Object.assign({
                            city_id: this.form.city.aoguid,
                            full_name: this.form.full_name,
                            phone: this.form.phone,
                            email: this.form.email
                        }, this.form.delivery_method.delivery_type === 'pvz' ? {
                            pvz: this.form.pvz
                        } : {
                            courier: this.form.courier
                        }),
                        products: this.form.productsItems
                    }
                }).then(() => {
                    this.$router.push({ name: 'OrdersTransferList' });
                });
            },
            cancel() {
                this.$router.push({ name: 'OrdersTransferList' });
            }
        },

        computed: {
            productsIsEditable() {
                // Пока даём возможность изменять данные о товарах только для Tilda,
                // так как для них не нужно делать синхронизацию с CMS.
                // Для остальных это не делаем, ибо будут вопросы,
                // "почему у меня в CMS 100руб, а выгрузилось 5000руб?", как мне кажется...
                return this.$store.state.localStorage.selectedShop.cms_id === 'Tilda Publishing';
            }
        },

        data() {
            return {
                SEARCH_DELIVERY_METHOD,

                currentItem: this.item,
                form: this.getForm(),

                REQUIRED_FIELDS: [
                    'full_name',
                    'phone',
                    'city',
                    'delivery_method',
                    'delivery_price'
                ],
                validation: {},

                editingProductItemIndex: undefined
            };
        }
    };
</script>

<style lang="stylus">
  $block = '.EditOrder'

  {$block}-ProductItem
    margin-bottom 5px

  {$block}-ProductItem-Code
    display inline-block

    /* top/bottom – для центрирования строки, left – для смещения текста к началу строки */
    margin -5px 0 -5px -4px

    max-width 180px
    overflow-x hidden
    text-overflow ellipsis
    white-space nowrap

  {$block}-EditingProductItem
    margin 20px 0 20px
</style>



// WEBPACK FOOTER //
// src/components/ordersTransfer/EditOrder.vue